import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const hmApi = createApi({
	reducerPath: 'hmApi',
	baseQuery: baseQueryWithReauth,
	endpoints: () => ({}),
});
